<template>
    <div class="houseClientReport">
        ====================》这是houseClientReport页
    </div>
</template>
<script>
export default {
    name:'houseClientReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// houseClientReport.vue?22110de6